import moment from "moment";
import { SIconType } from "@superwall-me/sui";
import { omit } from "es-toolkit";
// Unified ChartDefinitions array
export const ChartDefinitions = [
    {
        key: "noBreakdown",
        name: "None",
        description: "No breakdown",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "auto",
        name: "Auto",
        description: "Automatic selection",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "applicationId",
        name: "Application",
        description: "Unique identifier for the application",
        definitionTypes: []
    },
    {
        key: "installMonth",
        name: "Install Month",
        description: "Month when the app was installed",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "date",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "event"
            }
        ]
    },
    {
        key: "firstPurchaseMonth",
        name: "First Purchase Month",
        description: "Month of the user's first purchase",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "date",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "event"
            }
        ]
    },
    {
        key: "purchaseDate",
        name: "Purchase Date",
        description: "Date of purchase",
        definitionTypes: [
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "date"
            }
        ]
    },
    {
        key: "tsDate",
        name: "Event Date",
        description: "Date of the event",
        definitionTypes: [
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "date"
            }
        ]
    },
    {
        key: "mrrDate",
        name: "MRR Date",
        description: "Date of the MRR",
        definitionTypes: [
            {
                type: "xAxis",
                fillMissingValues: "cumulative",
                valueType: "date"
            }
        ]
    },
    {
        key: "installDate",
        name: "Install Date",
        description: "App install date",
        definitionTypes: [
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "date"
            }
        ]
    },
    {
        key: "firstPurchaseDate",
        name: "First Purchase Date",
        description: "Date the subscription started",
        definitionTypes: [
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "date"
            }
        ]
    },
    // appleSearchAdsAdGroupName
    // appleSearchAdsCampaignName
    // appleSearchAdsKeywordName
    // appleSearchAdsMatchType
    {
        key: "revenueType",
        name: "Renewal Type",
        description: "The type of revenue generated",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ]
            }
        ]
    },
    {
        key: "revenueSource",
        name: "Revenue Attribution",
        description: "Source of revenue (Superwall or Your App)",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ]
            }
        ]
    },
    {
        key: "autoRenewStatus",
        name: "Auto Renew Status",
        description: "The status of the auto renew",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "mrrEvents"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "mrrEvents"
                ]
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            }
        ]
    },
    {
        key: "subStartType",
        name: "Sub Start Type",
        description: "How a subscription was started",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents"
                ]
            }
        ]
    },
    {
        key: "eventType",
        name: "Event Type",
        description: "The type of event",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents"
                ]
            }
        ]
    },
    {
        key: "countryCode",
        name: "Country Code",
        description: "Two-letter country code",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "region",
        name: "Region",
        description: "Geographic region",
        definitionTypes: [
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "campaignId",
        name: "Campaign",
        description: "Unique identifier for the campaign",
        definitionTypes: [
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            },
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            }
        ]
    },
    {
        key: "placement",
        name: "Placement",
        description: "Location or context of the purchase",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    // {
    //   key: "audienceId",
    //   name: "Audience",
    //   description: "Unique identifier for the audience",
    //   definitionTypes: [
    //     {
    //       type: "filter",
    //       valueType: "string",
    //       dependsOn: "campaignId",
    //       queryCompatibilities: ["sdkEvents", "revenueEvents"],
    //     },
    //     {
    //       type: "xAxis",
    //       fillMissingValues: "zero",
    //       valueType: "string",
    //     },
    //     {
    //       type: "breakdown",
    //       valueType: "string",
    //       queryCompatibilities: ["sdkEvents", "revenueEvents"],
    //     },
    //   ],
    // },
    {
        key: "variantId",
        name: "Variant",
        description: "Unique identifier for the product variant",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                dependsOn: "campaignId",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "experimentId",
        name: "Audience",
        description: "Unique identifier for the experiment",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                dependsOn: "campaignId",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "productId",
        name: "Product",
        description: "Unique identifier for the product",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "productDuration",
        name: "Product Duration",
        description: "Duration of the product (e.g., subscription length)",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "paywallId",
        name: "Paywall",
        description: "Unique identifier for the paywall",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "integration",
        name: "Integration",
        description: "Third-party service or platform that sent Superwall the event",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "event"
            }
        ]
    },
    {
        key: "environment",
        name: "Environment",
        description: "Development environment (e.g., production, staging)",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "store",
        name: "Store",
        description: "App store or platform",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "appVersion",
        name: "App Version",
        description: "Version of the application",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "event"
            },
            {
                type: "xAxis",
                fillMissingValues: "zero",
                valueType: "string"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ]
            }
        ]
    },
    {
        key: "sdkVersion",
        name: "SDK Version",
        description: "Version of the SDK used",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ],
                group: "event"
            },
            {
                type: "filter",
                valueType: "string",
                queryCompatibilities: [
                    "sdkEvents",
                    "revenueEvents",
                    "mrrEvents",
                    "paidConversion"
                ]
            }
        ]
    },
    {
        key: "netProceeds",
        name: "Proceeds",
        description: "Revenue after refunds, store fees, and taxes",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    // netRevenue
    {
        key: "netRevenue",
        name: "Net Revenue",
        description: "Revenue after refunds, before store fees, and taxes",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    // refundRevenue
    {
        key: "refundRevenue",
        name: "Refunds",
        description: "Refunds, not including store fees or taxes",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    // taxesAndFeesRevenue
    {
        key: "taxesAndFeesRevenue",
        name: "Taxes & Fees",
        description: "Total amount of taxes and fees",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "grossRevenue",
        name: "Revenue",
        description: "Revenue before refunds, store fees, and taxes",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "mrr",
        name: "MRR",
        description: "Normalized recurring revenue, accounting for refunds",
        sourceQuery: "mrrEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "arr",
        name: "ARR",
        description: "Normalized recurring revenue, accounting for refunds",
        sourceQuery: "mrrEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "activeMrr",
        name: "Will Renew",
        description: "MRR from customers who haven't cancelled their subscriptions",
        sourceQuery: "mrrEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "subscribers",
        name: "Subscribers",
        description: "Count of active paid subscriptions",
        sourceQuery: "mrrEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "activeSubscribers",
        name: "Will Renew",
        description: "Active paid subscriptions from customers who haven't cancelled their subscriptions",
        sourceQuery: "mrrEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "grossProceeds",
        name: "Gross Proceeds",
        description: "Proceeds before refunds, after store fees, and taxes",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "refundProceeds",
        name: "Refund Proceeds",
        description: "Total amount of refunds",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "refundProceedsRate",
        name: "Refund Proceeds Rate",
        description: "Ratio of refunds to gross proceeds",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "nonRenewingRevenue",
        name: "Non-Renewing Revenue",
        description: "Revenue from non-renewing purchases",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "transactions",
        name: "Transactions",
        description: "Count of transactions with positive proceeds",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "refundTransactions",
        name: "Refund Transactions",
        description: "Count of transactions with negative proceeds",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialConversions",
        name: "Trial Conversions",
        description: "Count of trial conversions to paid subscriptions",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialPendings",
        name: "Pending Trials",
        description: "Count of trials that are active with auto-renew enabled, including customers in billing retry",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialBillingIssues",
        name: "Trial Billing Issues",
        description: "Count of trialing users set to convert but had billing issues",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "billingIssues",
        name: "Billing Issues",
        description: "Count of users set to renew but had billing issues",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialEnds",
        name: "Trial Ends",
        description: "Count of trials that have either converted or expired",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "transactionCompletes",
        name: "Conversions",
        description: "Count of unique conversions that occured on a paywall",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "subStarts",
        name: "Subscription Starts",
        description: "Number of new paid subscriptions, either from trial conversions, intro offers or direct subscriptions",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "directConversions",
        name: "Direct Conversions",
        description: "Count of direct purchases without trial or intro offer",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "introOfferConversions",
        name: "Intro Offer Conversions",
        description: "Count of conversions from intro offers",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialCancellations",
        name: "Trial Cancellations",
        description: "Count of trials that disabled auto-renew and will not convert",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "subscriptionCancellations",
        name: "Subscription Cancellations",
        description: "Count of cancellations for active subscriptions",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialExpirations",
        name: "Trial Expirations",
        description: "Count of trials that expired without conversion",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialStarts",
        name: "Trial Starts",
        description: "Count of users who started a trial",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "trialConversionRate",
        name: "Trial Conversion Rate",
        description: "Percentage of trial starts that converted to paid subscriptions",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "subscriptionExpirations",
        name: "Subscription Expirations",
        description: "Count of subscriptions that expired without renewal",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "newUsers",
        name: "New Users",
        description: "Count of new users",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "activeUsers",
        name: "Active Users",
        description: "Count of active users",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "paywallUsers",
        name: "Paywalled Users",
        description: "Count of users who opened paywalls",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "paywallUserRate",
        name: "Paywall Open Rate",
        description: "Percentage of users who opened the paywall",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "paywallConvRate",
        name: "Paywall Conv. Rate",
        description: "Percentage of users who converted after opening the paywall",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "initialConversions",
        name: "Converted Users",
        description: "Count of users who converted on a paywall",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "initialConvRate",
        name: "Conversion Rate",
        description: "Percentage of users who converted",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "transactionFailUsers",
        name: "Failed Checkout",
        description: "Count of users who's checkout failed",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "transactionAbandonUsers",
        name: "Abandoned Checkout",
        description: "Count of users who started checkout, but exited early",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "transactionStartUsers",
        name: "Started Checkout",
        description: "Count of users who started checkout",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "checkoutConvRate",
        name: "Checkout Conversion",
        description: "Percentage of users who converted after initiating checkout",
        sourceQuery: "sdkEvents",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "paidConversionRate",
        name: "Paid Conversion",
        description: "Percentage of installs that became paying users",
        sourceQuery: "paidConversion",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "percentage"
            }
        ]
    },
    {
        key: "payingUsers",
        name: "Paying Users",
        description: "Count of unique users who made a purchase",
        sourceQuery: "paidConversion",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "number"
            }
        ]
    },
    {
        key: "arpu",
        name: "ARPU",
        description: "Average Revenue Per User (Proceeds / New Users)",
        sourceQuery: "paidConversion",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "realizedLTV",
        name: "Realized LTV",
        description: "Realized Lifetime Value (Proceeds / Paying Users)",
        sourceQuery: "paidConversion",
        definitionTypes: [
            {
                type: "yAxis",
                valueType: "currency"
            }
        ]
    },
    {
        key: "appleSearchAdsCampaignName",
        name: "Campaign",
        meta: {
            platform: "IOS",
            searchAds: "advanced"
        },
        description: "The name of the campaign",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "apple_search_ads"
            }
        ]
    },
    {
        key: "appleSearchAdsAdGroupName",
        name: "Ad Group",
        meta: {
            platform: "IOS",
            searchAds: "advanced"
        },
        description: "The name of the ad group",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "apple_search_ads"
            }
        ]
    },
    {
        key: "appleSearchAdsKeywordName",
        name: "Keyword",
        meta: {
            platform: "IOS",
            searchAds: "advanced"
        },
        description: "The name of the keyword",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "apple_search_ads"
            }
        ]
    },
    {
        key: "appleSearchAdsMatchType",
        name: "Match Type",
        meta: {
            platform: "IOS",
            searchAds: "advanced"
        },
        description: "The match type of the ad",
        definitionTypes: [
            {
                type: "breakdown",
                valueType: "string",
                queryCompatibilities: [
                    "revenueEvents",
                    "mrrEvents"
                ],
                group: "apple_search_ads"
            }
        ]
    }
];
// newUsers
// activeUsers
// paywallUsers
// paywallUserRate
// paywallConvRate
// initialConversions
// initialConvRate
// transactionFailUsers
// transactionAbandonUsers
// transactionRestoreUsers
// transactionStartUsers
// checkoutConvRate
export const ChartTypeDefinitions = [
    {
        key: "grossProceeds",
        group: "Revenue",
        style: {
            icon: SIconType.Proceeds
        },
        name: "Proceeds",
        description: "Revenue after store fees and taxes, but before refunds.",
        xAxis: "purchaseDate",
        yAxis: "grossProceeds",
        dateDimension: "purchaseDate",
        defaultBreakdown: "revenueType",
        include: []
    },
    {
        key: "sales",
        group: "Revenue",
        style: {
            icon: SIconType.Product
        },
        name: "Sales",
        description: "Revenue before refunds taxes and fees",
        xAxis: "purchaseDate",
        yAxis: "grossRevenue",
        dateDimension: "purchaseDate",
        // defaultBreakdown: "revenueType",
        include: [
            "netProceeds",
            "refundRevenue",
            "taxesAndFeesRevenue"
        ]
    },
    {
        key: "cohortedProceeds",
        group: "Revenue",
        style: {
            icon: SIconType.Calendar
        },
        name: "Cohorted Proceeds",
        description: "Net proceeds cohorted by Install Date, after refunds, taxes, and fees. Usually used in comparison to Ad Spend. Only includes revenue generated by Superwall.",
        xAxis: "installDate",
        yAxis: "netProceeds",
        dateDimension: "installDate",
        // defaultBreakdown: "revenueType",
        include: []
    },
    {
        key: "arr",
        group: "Revenue",
        style: {
            icon: SIconType.MRR
        },
        name: "ARR",
        description: "Normalized revenue from subscriptions to an annual period until their expiration. Doesn't factor in auto renew status.",
        xAxis: "mrrDate",
        yAxis: "arr",
        dateDimension: "mrrDate",
        include: []
    },
    {
        key: "mrr",
        group: "Revenue",
        style: {
            icon: SIconType.MRR
        },
        name: "MRR",
        description: "Normalized revenue from subscriptions to a monthly period until their expiration. Doesn't factor in auto renew status.",
        xAxis: "mrrDate",
        yAxis: "mrr",
        dateDimension: "mrrDate",
        include: []
    },
    {
        key: "newUsers",
        group: "Users",
        style: {
            icon: SIconType.CampaignUsers
        },
        name: "New Users",
        description: "Count of new users",
        xAxis: "installDate",
        yAxis: "newUsers",
        dateDimension: "installDate",
        include: [
            "paywallUsers",
            "initialConversions"
        ]
    },
    {
        key: "activeUsers",
        group: "Users",
        style: {
            icon: SIconType.Users
        },
        name: "Active Users",
        description: "Count of active users",
        xAxis: "tsDate",
        yAxis: "activeUsers",
        dateDimension: "tsDate",
        include: [
            "paywallUsers",
            "initialConversions"
        ]
    },
    {
        key: "initialConvRate",
        group: "Paywalls",
        style: {
            icon: SIconType.FunnelLines
        },
        name: "Initial Conversion",
        description: "Percent of new users who converted on a paywall",
        xAxis: "installDate",
        yAxis: "initialConvRate",
        dateDimension: "installDate",
        defaultChartType: "line",
        include: [
            "newUsers",
            "initialConversions"
        ]
    },
    {
        key: "paywalledUsers",
        group: "Paywalls",
        style: {
            icon: SIconType.PaywalledUser
        },
        name: "Paywalled Users",
        description: "Count of unique active users who opened paywalls",
        xAxis: "tsDate",
        yAxis: "paywallUsers",
        dateDimension: "tsDate",
        include: [
            "activeUsers",
            "paywallUserRate"
        ]
    },
    {
        key: "subscribers",
        group: "Subscriptions",
        style: {
            icon: SIconType.ActiveSubscriptions
        },
        name: "Active Subscriptions",
        description: "Count of unexpired, paid subscriptions. Doesn't factor in auto renew status. Shows how many users have access to your product at a point in time.",
        xAxis: "mrrDate",
        yAxis: "subscribers",
        dateDimension: "mrrDate",
        include: []
    },
    {
        key: "paidConversionRate",
        group: "Subscriptions",
        style: {
            icon: SIconType.FunnelLines
        },
        name: "Paid Conversion",
        description: "Percent of installs who became paying users",
        xAxis: "installDate",
        yAxis: "paidConversionRate",
        dateDimension: "installDate",
        defaultChartType: "line",
        include: [
            "newUsers",
            "payingUsers"
        ]
    },
    {
        key: "trials",
        group: "Subscriptions",
        style: {
            icon: SIconType.Trial
        },
        name: "New Trials",
        description: "Trial starts, cohorted by trial start date",
        xAxis: "purchaseDate",
        yAxis: "trialStarts",
        dateDimension: "purchaseDate",
        // include: ["trialPendings", "trialCancellations", "trialBillingIssues", "trialConversions"],
        include: []
    },
    {
        key: "trialConversionRate",
        group: "Subscriptions",
        style: {
            icon: SIconType.Funnel
        },
        name: "Trial Conversion",
        description: "Percentage of trials that converted to paid subscriptions. NOTE: only includes trials started on a Superwall paywall.",
        xAxis: "firstPurchaseDate",
        yAxis: "trialConversionRate",
        dateDimension: "firstPurchaseDate",
        defaultChartType: "line",
        include: [
            "trialStarts",
            "trialConversions",
            "trialPendings",
            "trialCancellations"
        ]
    },
    {
        key: "subscriptions",
        group: "Subscriptions",
        style: {
            icon: SIconType.Subscription
        },
        name: "New Subscriptions",
        description: "New subscriptions, cohorted by subscription start date",
        xAxis: "purchaseDate",
        yAxis: "subStarts",
        dateDimension: "purchaseDate",
        defaultBreakdown: "subStartType",
        include: []
    },
    {
        key: "renewalStatus",
        group: "Subscriptions",
        style: {
            icon: SIconType.AutoRenew
        },
        name: "Auto Renew Status",
        description: "How much of your MRR is set to renew vs churn.",
        xAxis: "autoRenewStatus",
        yAxis: "mrr",
        defaultChartType: "bar",
        dateDimension: "mrrDate",
        include: [
            "subscribers"
        ]
    },
    {
        key: "paywallUserRate",
        group: "Paywalls",
        style: {
            icon: SIconType.PaywallRate
        },
        name: "Paywall Rate",
        description: "Percent of new users who opened paywalls",
        xAxis: "installDate",
        yAxis: "paywallUserRate",
        dateDimension: "installDate",
        include: [
            "newUsers",
            "paywallUsers"
        ]
    },
    {
        key: "paywallConversion",
        group: "Paywalls",
        style: {
            icon: SIconType.PaywallConversionRate
        },
        name: "Paywall Conversion",
        description: "Count of users who opened paywalls",
        xAxis: "tsDate",
        yAxis: "paywallConvRate",
        dateDimension: "tsDate",
        defaultChartType: "line",
        include: [
            "paywallUsers",
            "initialConversions"
        ]
    },
    {
        key: "transactionCompletes",
        group: "Paywalls",
        style: {
            icon: SIconType.PaywallConversion
        },
        name: "Conversions",
        description: "Count of paywall conversions (transaction_complete)",
        xAxis: "purchaseDate",
        yAxis: "transactionCompletes",
        dateDimension: "purchaseDate",
        include: []
    },
    {
        key: "checkoutConvRate",
        group: "Paywalls",
        style: {
            icon: SIconType.Checkout
        },
        name: "Checkout Conversion",
        description: "Percentage of users who converted after starting checkout",
        xAxis: "tsDate",
        yAxis: "checkoutConvRate",
        dateDimension: "tsDate",
        defaultChartType: "line",
        include: [
            "transactionStartUsers",
            "transactionAbandonUsers",
            "transactionFailUsers",
            "initialConversions"
        ]
    },
    {
        key: "refundProceedsRate",
        group: "Retention & Churn",
        style: {
            icon: SIconType.Refresh
        },
        name: "Refund Rate",
        description: "Ratio of refunds to gross proceeds, cohorted by first purchase date",
        xAxis: "purchaseDate",
        yAxis: "refundProceedsRate",
        dateDimension: "purchaseDate",
        defaultChartType: "line",
        include: [
            "refundProceeds",
            "grossProceeds"
        ]
    },
    {
        key: "arpu",
        group: "Revenue",
        style: {
            icon: SIconType.Proceeds
        },
        name: "ARPU",
        description: "Average Revenue Per User cohorted by install date",
        xAxis: "installDate",
        yAxis: "arpu",
        dateDimension: "installDate",
        defaultChartType: "line",
        include: [
            "newUsers",
            "netProceeds"
        ]
    },
    {
        key: "realizedLTV",
        group: "Revenue",
        style: {
            icon: SIconType.Calendar
        },
        name: "Realized LTV",
        description: "Realized Lifetime Value cohorted by install date",
        xAxis: "installDate",
        yAxis: "realizedLTV",
        dateDimension: "installDate",
        defaultChartType: "line",
        include: [
            "payingUsers",
            "netProceeds"
        ]
    }
];
export const ChartOverviewDefinitions = [
    {
        key: "totalNetProceeds",
        name: "Total Net Proceeds",
        description: "Total proceeds after refunds, store fees, and taxes",
        valueType: "currency"
    },
    {
        key: "averageNetProceeds",
        name: "Average Net Proceeds",
        description: "Average proceeds per transaction after refunds, store fees, and taxes",
        valueType: "currency"
    },
    {
        key: "totalTransactions",
        name: "Total Transactions",
        description: "Total number of transactions",
        valueType: "number"
    },
    {
        key: "averageTransactions",
        name: "Average Transactions",
        description: "Average number of transactions per period",
        valueType: "number"
    },
    {
        key: "totalRefundProceeds",
        name: "Total Refund Amount",
        description: "Total amount refunded",
        valueType: "currency"
    },
    {
        key: "averageRefundRate",
        name: "Average Refund Rate",
        description: "Average percentage of transactions that were refunded",
        valueType: "percentage"
    },
    {
        key: "totalTrialConversions",
        name: "Total Trial Conversions",
        description: "Total number of trial conversions",
        valueType: "number"
    },
    {
        key: "totalDirectConversions",
        name: "Total Direct Conversions",
        description: "Total number of direct conversions without trial",
        valueType: "number"
    },
    {
        key: "totalIntroOfferConversions",
        name: "Total Intro Offer Conversions",
        description: "Total number of intro offer conversions",
        valueType: "number"
    },
    {
        key: "averageConversionRate",
        name: "Average Conversion Rate",
        description: "Average percentage of trials or offers that converted",
        valueType: "percentage"
    },
    {
        key: "totalSubscriptionCancellations",
        name: "Total Subscription Cancellations",
        description: "Total number of subscription cancellations",
        valueType: "number"
    }
];
export const OverviewCardDefinitions = {
    netProceeds: [
        "totalNetProceeds",
        "averageNetProceeds",
        "totalTransactions",
        "averageTransactions"
    ],
    refundProceeds: [
        "totalRefundProceeds",
        "averageRefundRate",
        "totalNetProceeds",
        "totalTransactions"
    ],
    transactions: [
        "totalTransactions",
        "averageTransactions",
        "totalNetProceeds",
        "averageNetProceeds"
    ],
    trialConversions: [
        "totalTrialConversions",
        "totalDirectConversions",
        "totalIntroOfferConversions",
        "averageConversionRate"
    ],
    subscriptionCancellations: [
        "totalSubscriptionCancellations",
        "totalTransactions",
        "totalNetProceeds",
        "averageNetProceeds"
    ],
    default: [
        "totalNetProceeds",
        "totalTransactions",
        "averageConversionRate",
        "averageRefundRate"
    ]
};
export const transformDateParam = (preset)=>{
    const today = moment().utc().startOf("day");
    const yesterday = moment().utc().subtract(1, "day").startOf("day");
    const last24Hours = moment().utc().endOf("hour").subtract(24, "hours");
    const last7 = moment().utc().subtract(6, "day").startOf("day");
    const last30 = moment().utc().subtract(29, "day").startOf("day");
    const last90 = moment().utc().subtract(89, "day").startOf("day");
    const last180 = moment().utc().subtract(179, "day").startOf("day");
    const last365 = moment().utc().subtract(364, "day").startOf("day");
    const ytd = moment().utc().startOf("year");
    const f = "YYYY-MM-DDTHH:mm:ss";
    const nowFormatted = moment().utc().endOf("hour").format(f);
    switch(preset){
        case "last_24_hours":
            return {
                range: {
                    from: last24Hours.format(f),
                    to: nowFormatted
                }
            };
        case "today":
            return {
                range: {
                    from: today.format(f),
                    to: nowFormatted
                }
            };
        case "yesterday":
            return {
                range: {
                    from: yesterday.format(f),
                    to: yesterday.endOf("day").format(f)
                }
            };
        case "last_7_days":
            return {
                range: {
                    from: last7.format(f),
                    to: nowFormatted
                }
            };
        case "last_30_days":
            return {
                range: {
                    from: last30.format(f),
                    to: nowFormatted
                }
            };
        case "last_90_days":
            return {
                range: {
                    from: last90.format(f),
                    to: nowFormatted
                }
            };
        case "last_180_days":
            return {
                range: {
                    from: last180.format(f),
                    to: nowFormatted
                }
            };
        case "last_365_days":
            return {
                range: {
                    from: last365.format(f),
                    to: nowFormatted
                }
            };
        case "year_to_date":
            return {
                range: {
                    from: ytd.format(f),
                    to: nowFormatted
                }
            };
        case "custom":
            return {
                range: {
                    from: last7.format(f),
                    to: nowFormatted
                }
            };
    }
};
export const getDateFilterDefinitions = ()=>{
    return [
        {
            name: "Last 24 Hours",
            preset: "last_24_hours",
            active: false,
            ...transformDateParam("last_24_hours")
        },
        {
            name: "Today",
            preset: "today",
            active: false,
            ...transformDateParam("today")
        },
        {
            name: "Yesterday",
            preset: "yesterday",
            active: false,
            ...transformDateParam("yesterday")
        },
        {
            name: "Last 7 Days",
            preset: "last_7_days",
            active: true,
            ...transformDateParam("last_7_days")
        },
        {
            name: "Last 30 Days",
            preset: "last_30_days",
            active: false,
            ...transformDateParam("last_30_days")
        },
        {
            name: "Last 90 Days",
            preset: "last_90_days",
            active: false,
            ...transformDateParam("last_90_days")
        },
        {
            name: "Last 180 Days",
            preset: "last_180_days",
            active: false,
            ...transformDateParam("last_180_days")
        },
        {
            name: "Last 365 Days",
            preset: "last_365_days",
            active: false,
            ...transformDateParam("last_365_days")
        },
        {
            name: "Year to Date",
            preset: "year_to_date",
            active: false,
            ...transformDateParam("year_to_date")
        },
        {
            name: "Custom",
            preset: "custom",
            active: false,
            ...transformDateParam("custom")
        }
    ];
};
export const DateIntervalDefinitions = [
    {
        key: "hour",
        name: "Hourly",
        description: "Hourly interval",
        type: "dateInterval",
        valueType: "string",
        active: false
    },
    {
        key: "day",
        name: "Daily",
        description: "Daily interval",
        type: "dateInterval",
        valueType: "string",
        active: false
    },
    {
        key: "week",
        name: "Weekly",
        description: "Weekly interval",
        type: "dateInterval",
        valueType: "string",
        active: false
    },
    {
        key: "month",
        name: "Monthly",
        description: "Monthly interval",
        type: "dateInterval",
        valueType: "string",
        active: false
    },
    {
        key: "quarter",
        name: "Quarterly",
        description: "Quarterly interval",
        type: "dateInterval",
        valueType: "string",
        active: false
    },
    {
        key: "year",
        name: "Yearly",
        description: "Yearly interval",
        type: "dateInterval",
        valueType: "string",
        active: false
    }
];
// Updated filtered and mapped arrays
export const breakdownDefinitions = ChartDefinitions.filter((def)=>def.definitionTypes.some((type)=>type.type === "breakdown")).map((def)=>({
        ...omit(def, [
            "definitionTypes"
        ]),
        ...def.definitionTypes.find((type)=>type.type === "breakdown")
    }));
export const filterDefinitions = ChartDefinitions.filter((def)=>def.definitionTypes.some((type)=>type.type === "filter")).map((def)=>({
        ...omit(def, [
            "definitionTypes"
        ]),
        ...def.definitionTypes.find((type)=>type.type === "filter")
    }));
export const xAxisDefinitions = ChartDefinitions.filter((def)=>def.definitionTypes.some((type)=>type.type === "xAxis")).map((def)=>{
    const found = def.definitionTypes.find((type)=>type.type === "xAxis");
    return {
        ...omit(def, [
            "definitionTypes"
        ]),
        ...found,
        ...found.valueType === "date" && {
            dateIntervals: DateIntervalDefinitions
        }
    };
});
export const yAxisDefinitions = ChartDefinitions.filter((def)=>def.definitionTypes.some((type)=>type.type === "yAxis")).map((def)=>({
        ...omit(def, [
            "definitionTypes"
        ]),
        ...def.definitionTypes.find((type)=>type.type === "yAxis")
    }));
